import { required } from 'utils/errorsTextHelper';
import * as yup from 'yup';

import { EFacebookButtonVariant } from './types';

export const loginValidationSchema = yup.object().shape({
  text: yup.string().required(required('Header')),
  textColor: yup.string().required(required('Font color')),
  textSize: yup
    .number()
    .typeError(required('Font size'))
    .required(required('Font size')),
  loginLogoImage: yup.string().notRequired(),
  loginBackgroundImageMobile: yup.string().notRequired(),
  loginBackgroundImageDesktop: yup.string().notRequired(),
  loginLogoSize: yup.string().required(required('Logo size')),
  otpButton: yup.object().shape({
    backgroundColor: yup.object().shape({
      colorOne: yup.string().required(required('Button main color')),
      colorTwo: yup.string()
    }),
    text: yup.string(),
    icon: yup.string(),
    textColor: yup.object().shape({
      colorOne: yup.string().required(required('Text main color')),
      colorTwo: yup.string()
    })
  }),
  playerIdButton: yup.object().shape({
    backgroundColor: yup.object().shape({
      colorOne: yup.string(),
      colorTwo: yup.string()
    }),
    text: yup.string(),
    icon: yup.string(),
    textColor: yup.object().shape({
      colorOne: yup.string(),
      colorTwo: yup.string()
    })
  }),
  logoutScreen: yup.object().shape({
    text: yup.string(),
    font: yup.string(),
    textColor: yup.string().required(required('Font color')),
    textSize: yup
      .number()
      .typeError(required('Font size'))
      .required(required('Font size')),
    textWeight: yup.string(),
    customCloseIcon: yup.string(),
    buttonImage: yup.string()
  }),
  facebookButton: yup.object().shape({
    variant: yup.string().oneOf(Object.values(EFacebookButtonVariant), 'Invalid variant').required(required('Button variant'))
  }),
  consentSection: yup.object().shape({
    htmlText: yup.string(),
    consentRequired: yup.boolean()
  }),
  accountApprovalModal: yup.object().shape({
    backgroundImage: yup.string().required(required('Background image')),
    backgroundColor: yup.object().shape({
      colorOne: yup.string().required(required('Background color')),
      colorTwo: yup.string()
    }),
    buttonBackgroundColor: yup.object().shape({
      colorOne: yup.string().required(required('Button background color')),
      colorTwo: yup.string()
    }),
    borderWidth: yup
      .number()
      .min(0, 'Border width cannot be negative')
      .max(20, 'Border width cannot be bigger than 20px'),
    additionalText: yup.string()
  })
});
